import PageContainerBlank from '../../components/PageContainer/PageContainerBlank';
import PageEndBlank from '../../components/PageContainer/PageEndBlank';
import './CalendarInstructions.css';

const UpcomingEvents = () => {
	return (
		<div>
			<PageContainerBlank />

			<p></p><iframe className="invertable" src="https://calendar.google.com/calendar/embed?src=hanoverholyname%40gmail.com&ctz=America%2FNew_York&mode=AGENDA&showTitle=0&showPrint=0&showCalendars=0" title="HNS Events Calendar" style={{ width: '100%' }} width="800" height="600" frameborder="0"></iframe>

			<p className="desktop-only">To save this calendar to your own, click the add button in the bottom left corner of the calendar!</p>
			<div className="desktop-only desktop-add-calendar"></div>

			<p className="mobile-only">To save this calendar to your own, tap the add button in the bottom right corner of the calendar!</p>
			<div className="mobile-only mobile-add-calendar"></div>

			<p>After saving, these events will reflect on your personal calendar!</p>

			<PageEndBlank />
		</div>
	);
};

export default UpcomingEvents;